// src/data/towns.js
export const towns = [
  {
    slug: "belfast",
    name: "Belfast",
    metaTitle: "Party Decorations Belfast | Balloons, Backdrops & Venue Décor",
    metaDescription:
      "Party decorators in Belfast for balloons, backdrops, party packages and full venue styling. Instant WhatsApp quote. Setup & takedown included.",
    h1: "Party Decorations in Belfast",
    nearby: ["newtownabbey", "lisburn", "holywood", "carrickfergus", "bangor"],
    localIntro: "Belfast is our home base and the city we know best. From intimate home setups in East Belfast to full venue styling in the city centre, we’ve delivered hundreds of celebrations across the city.",
    faqs: [
      { q: "How far in advance should I book?", a: "2–4 weeks is ideal; peak weekends fill earlier." },
      { q: "Do you handle delivery, setup and takedown?", a: "Yes—Belfast bookings include delivery, full setup and takedown." },
      { q: "Can you match a colour palette or theme?", a: "Absolutely—share your inspo or brand colours." },
      { q: "Do you work with venues?", a: "Yes—we coordinate with venues for smooth access and timings." },
      { q: "Is there a deposit?", a: "A small deposit secures your date; balance is due before the event." },
      { q: "Do you decorate for christenings in Belfast?", a: "Yes—elegant balloon garlands, personalised welcome boards and shimmer wall backdrops are popular for christening setups across Belfast." },
      { q: "Can you style hen parties and 18th or 21st birthday parties in Belfast?", a: "Yes—neon signs, sequin walls, personalised backdrops and personalised foil numbers are our most popular choices for hen parties, 18ths and 21sts." },
      { q: "Can you help if I am looking for party planners in Belfast?", a: "We focus on party decor rather than full event planning, but we can coordinate styling, setup timings and venue access so your party decorations are handled professionally." },
    ],
    alt1: "Balloon garland in Belfast living room—blush, white and gold balloons framing a shimmer wall with ‘Happy Birthday’ neon; Party Crafters setup and styling.",
    alt2: "Personalised acrylic welcome board on easel with soft florals and balloon cluster at a Belfast venue entrance; Party Crafters décor.",
  },
  {
    slug: "lisburn",
    name: "Lisburn",
    metaTitle: "Party Decorations Lisburn | Balloons, Backdrops & Venue Décor",
    metaDescription:
      "Balloon garlands, shimmer walls, welcome boards and full venue styling in Lisburn. Delivery, setup & takedown included. Instant WhatsApp quote.",
    h1: "Party Decorations in Lisburn",
    nearby: ["belfast", "newtownabbey", "carryduff", "hillsborough"],
    localIntro: "Lisburn is one of our most popular areas outside Belfast. We regularly style events at homes, hotels and community halls throughout the city, covering the full BT27 and BT28 postcodes.",
    faqs: [
      { q: "How soon should I book for Lisburn?", a: "2–4 weeks is ideal; peak weekends fill earlier." },
      { q: "Do you handle delivery, setup and takedown?", a: "Yes, included for Lisburn bookings." },
      { q: "Can you match a colour palette or theme?", a: "Absolutely; share inspo or brand colours." },
      { q: "Are there travel fees?", a: "None within Lisburn; a small fee may apply outside." },
      { q: "Indoor vs outdoor installs?", a: "We’ll advise best options based on weather and surfaces." },
      { q: "Do you do baby shower decorations in Lisburn?", a: "Yes—soft balloon garlands, personalised welcome boards and themed backdrops are popular for baby showers across Lisburn." },
      { q: "Can you style birthday parties and hen parties in Lisburn?", a: "Yes—we style 18th and 21st birthday parties, hen party setups, christenings and all celebrations in Lisburn with delivery, setup and takedown included." },
    ],
    alt1: "personalised foil numbers ‘40’ with chrome accents and matching mini garland in a Lisburn home; Party Crafters birthday décor.",
    alt2: "Sequin backdrop with themed balloon garland and plinth trio styled for a Lisburn party; Party Crafters installation.",
  },
  {
    slug: "newtownabbey",
    name: "Newtownabbey",
    metaTitle: "Party Decorations Newtownabbey | Balloons, Backdrops & Venue Décor",
    metaDescription:
      "Surprise Room Décor, balloon garlands, shimmer walls and welcome boards in Newtownabbey. Fast WhatsApp quote. Setup & takedown handled.",
    h1: "Party Decorations in Newtownabbey",
    nearby: ["belfast", "glengormley", "jordanstown", "carrickfergus"],
    localIntro: "Newtownabbey is just north of Belfast and one of our busiest areas. We cover Glengormley, Jordanstown, Whiteabbey and all surrounding estates — with no fuss and everything handled for you.",
    faqs: [
      { q: "What’s the minimum order in Newtownabbey?", a: "Surprise Room Décor starts from £250; message us for a quick quote." },
      { q: "How long do setups take?", a: "Most installs take 60–90 minutes; takedown 30–45 minutes." },
      { q: "Can you do last-minute bookings?", a: "If the slot is open, yes—WhatsApp is fastest." },
      { q: "Do you supply stands or easels?", a: "Yes, plus optional florals and signage." },
      { q: "Will balloons last outdoors?", a: "We specify outdoor-friendly options when conditions allow." },
      { q: "Do you style baby showers and christenings in Newtownabbey?", a: "Yes—we do baby shower decor, christening setups, hen party styling and birthday decorations across Newtownabbey with full setup and takedown." },
      { q: "Can you style 18th and 21st birthday parties in Newtownabbey?", a: "Yes—balloon garlands, shimmer walls, personalised foil numbers and neon signs are popular for milestone birthdays in Newtownabbey." },
    ],
    alt1: "Balloon arch in Newtownabbey community hall—sage, ivory and chrome gold tones framing the cake table; Party Crafters setup.",
    alt2: "Welcome board with easel and floral cluster at Newtownabbey venue foyer, paired with compact balloon display; Party Crafters décor.",
  },
  {
    slug: "bangor",
    name: "Bangor",
    metaTitle: "Party Decorations Bangor | Balloons, Backdrops & Venue Décor",
    metaDescription:
      "Party decorators in Bangor for birthday parties, balloon arches, personalised foil numbers, backdrops and welcome signs. Delivery, setup & takedown included.",
    h1: "Party Decorations in Bangor",
    nearby: ["newtownards", "holywood", "belfast"],
    localIntro: "Bangor's coastal setting makes it a favourite for garden parties, hotel events, birthday parties and venue celebrations. We style balloon arches, personalised foil numbers, backdrops and welcome boards across BT19 and BT20, including homes, hotels and venues along the seafront.",
    faqs: [
      { q: "Do you cover seaside or outdoor venues in Bangor?", a: "Yes; we plan installs suitable for wind and exposure." },
      { q: "Can you match coastal colour palettes?", a: "We can design around your theme and venue colours." },
      { q: "Do you remove décor after the event?", a: "Yes—takedown is usually next day." },
      { q: "Do you work with photographers?", a: "Yes, we can coordinate timings for best shots." },
      { q: "Can I keep my welcome sign?", a: "Hire or purchase options are available." },
      { q: "Do you do baby shower and christening decorations in Bangor?", a: "Yes—soft balloon garlands, personalised welcome boards and styled backdrops for baby showers and christenings across Bangor." },
      { q: "Can you style 18th and 21st birthday parties in Bangor?", a: "Yes—personalised foil numbers, neon signs, shimmer walls and balloon garlands for milestone birthdays in Bangor, with full setup and takedown." },
      { q: "Can you suggest birthday party decoration ideas in Bangor?", a: "Yes—popular Bangor birthday setups include a balloon arch around the cake table, a shimmer wall photo spot, a personalised welcome board and personalised foil numbers for milestone ages." },
      { q: "Do you provide balloon arches and garlands in Bangor?", a: "Yes, we provide balloon garlands and arch-style displays for entrances, cake tables and photo spots across Bangor and nearby towns." },
    ],
    alt1: "Coastal-inspired balloon garland in Bangor—seafoam, pearl white and sand hues around a photo backdrop; Party Crafters styling.",
    alt2: "Elegant Bangor garden party setup—balloon demi-arch, rustic table styling and personalised welcome sign; Party Crafters.",
  },
  {
    slug: "newtownards",
    name: "Newtownards",
    metaTitle: "Party Decorations Newtownards | Balloons, Backdrops & Venue Décor",
    metaDescription:
      "Professional balloon décor, themed backdrops and custom welcome boards in Newtownards. Quick WhatsApp quotes. Full setup & takedown.",
    h1: "Party Decorations in Newtownards",
    nearby: ["bangor", "comber", "dundonald", "belfast"],
    localIntro: "Newtownards is a growing town with a great mix of home parties, local venues and hotel celebrations. We cover all of the BT23 postcode and the surrounding Ards Peninsula area.",
    faqs: [
      { q: "Do you require a deposit?", a: "Yes, a small deposit secures your date." },
      { q: "How far in advance should I book?", a: "We recommend 2–4 weeks; earlier for peak weekends." },
      { q: "Can you style tight spaces?", a: "Yes; we design to suit ceilings, access and room flow." },
      { q: "Do you supply neons or plinths?", a: "Yes—available as add-ons." },
      { q: "What if my venue has restrictions?", a: "We coordinate with the venue and adapt to requirements." },
      { q: "Do you do baby shower and gender reveal decorations in Newtownards?", a: "Yes—soft garlands, themed backdrops and personalised welcome boards for baby showers and gender reveals across Newtownards." },
      { q: "Can you style 18th and 21st birthday parties in Newtownards?", a: "Yes—balloon garlands, shimmer walls, personalised foil numbers and neon signs for milestone birthdays in Newtownards with delivery, setup and takedown." },
    ],
    alt1: "Balloon frame with soft blush and ivory tones around a shimmer panel in Newtownards venue; Party Crafters event décor.",
    alt2: "Custom welcome board on black metal easel with neutral florals and mini balloon cluster at Newtownards entrance; Party Crafters.",
  },
  {
    slug: "antrim",
    name: "Antrim",
    metaTitle: "Party Decorations Antrim | Balloons, Backdrops & Venue Décor",
    metaDescription:
      "Surprise Room Décor and full venue décor in Antrim, with professional styling, setup and takedown included. Message us for a fast quote.",
    h1: "Party Decorations in Antrim",
    nearby: ["ballyclare", "templepatrick", "belfast", "randalstown"],
    faqs: [
      { q: "Do you offer kids’ birthday packages?", a: "Yes—popular bundles pair a personalised foil numbers with a themed backdrop." },
      { q: "How long will balloons last?", a: "Indoors 2–5 days; outdoors depends on weather." },
      { q: "Can you work to a budget?", a: "Yes—we’ll tailor options at different price points." },
      { q: "Do you remove everything after?", a: "Yes—takedown is included." },
      { q: "Can I add a personalised welcome sign?", a: "Yes—acrylic, foam or mirror with easel/florals available." }
    ],
    alt1: "Antrim birthday setup—personalised foil numbers with chrome rose gold and coordinating garland beside the dessert table; Party Crafters.",
    alt2: "Neutral-toned backdrop with dried florals, acrylic sign and soft balloon garland at an Antrim venue; Party Crafters styling.",
  },
  {
    slug: "carrickfergus",
    name: "Carrickfergus",
    metaTitle: "Party Decorations Carrickfergus | Balloons, Backdrops & Venue Décor",
    metaDescription:
      "Stunning balloon décor, themed backdrops and custom signage in Carrickfergus. Setup & takedown handled. WhatsApp us for availability.",
    h1: "Party Decorations in Carrickfergus",
    nearby: ["newtownabbey", "whitehead", "greenisland", "belfast"],
    faqs: [
      { q: "Can you style heritage or older buildings?", a: "Yes—we use non-marking, venue-friendly methods." },
      { q: "Do you offer evening takedown?", a: "Takedown is usually next-day; same-night can be arranged." },
      { q: "Can you include brand logos?", a: "Yes—custom signage and colour matching available." },
      { q: "Do you provide moodboards?", a: "A moodboard is included with full styling packages." },
      { q: "Is there a minimum spend?", a: "Small installs from £—; WhatsApp us for a quick quote." }
    ],
    alt1: "Carrickfergus heritage-friendly install—non-marking balloon garland and freestanding shimmer wall with neon; Party Crafters décor.",
    alt2: "Corporate welcome board with brand colours and compact balloon display at Carrickfergus event space; Party Crafters.",
  },

  /* ---------- Newly added towns referenced in nearby[] ---------- */

  {
    slug: "holywood",
    name: "Holywood",
    metaTitle: "Party Decorations Holywood | Balloons, Backdrops & Venue Décor",
    metaDescription:
      "Party décor in Holywood: balloon garlands, personalised foil numbers, backdrops and welcome boards. Delivery, setup & takedown included.",
    h1: "Party Decorations in Holywood",
    nearby: ["belfast", "bangor", "newtownards"],
    faqs: [
      { q: "How far in advance should I book?", a: "2–4 weeks is ideal; earlier for peak weekends." },
      { q: "Do you handle delivery and takedown?", a: "Yes—fully handled by our team." },
      { q: "Can you match my theme?", a: "Yes—share inspiration or brand colours." },
      { q: "Are there travel fees?", a: "Local travel typically included; we’ll confirm on quote." },
      { q: "Outdoor setups?", a: "We advise weather-friendly options if outdoors." }
    ],
    alt1: "Balloon garland and shimmer panel styled at a Holywood venue entrance; Party Crafters décor.",
    alt2: "Personalised welcome board with balloon cluster for a Holywood celebration; Party Crafters setup.",
  },
  {
    slug: "carryduff",
    name: "Carryduff",
    metaTitle: "Party Decorations Carryduff | Balloons, Backdrops & Venue Décor",
    metaDescription:
      "Balloon décor, backdrops and welcome signs in Carryduff. Quick WhatsApp quotes. Delivery, setup & takedown included.",
    h1: "Party Decorations in Carryduff",
    nearby: ["lisburn", "belfast", "hillsborough"],
    faqs: [
      { q: "What’s the lead time?", a: "2–4 weeks recommended; we can try last-minute if slots are open." },
      { q: "Do you install and remove?", a: "Yes—full setup and takedown included." },
      { q: "Do you offer personalised signage?", a: "Yes—acrylic, foam or mirror boards available." },
      { q: "Can you work to a budget?", a: "Yes—options at different price points." },
      { q: "Venue coordination?", a: "We coordinate access and timings with your venue." }
    ],
    alt1: "Themed balloon demi-arch with shimmer backdrop at a Carryduff event; Party Crafters.",
    alt2: "personalised foil numbers with chrome accents beside a personalised welcome board in Carryduff; Party Crafters décor.",
  },
  {
    slug: "hillsborough",
    name: "Hillsborough",
    metaTitle: "Party Decorations Hillsborough | Balloons, Backdrops & Venue Décor",
    metaDescription:
      "Event styling in Hillsborough—balloon garlands, themed backdrops and welcome boards. Delivery, setup & takedown included.",
    h1: "Party Decorations in Hillsborough",
    nearby: ["lisburn", "carryduff", "belfast"],
    faqs: [
      { q: "How do I book?", a: "Message us on WhatsApp with your date, venue and theme." },
      { q: "What’s included?", a: "Delivery, professional setup and takedown." },
      { q: "Can you match venue colours?", a: "Yes—we design to suit the space and palette." },
      { q: "Outdoor installs?", a: "We’ll advise suitable options for weather and surfaces." },
      { q: "Deposit?", a: "A small deposit secures your date." }
    ],
    alt1: "Elegant balloon garland and welcome sign at a Hillsborough venue entrance; Party Crafters.",
    alt2: "Sequin wall with coordinated balloon styling for a Hillsborough celebration; Party Crafters.",
  },
  {
    slug: "glengormley",
    name: "Glengormley",
    metaTitle: "Party Decorations Glengormley | Balloons, Backdrops & Venue Décor",
    metaDescription:
      "Surprise Room Décor, balloon garlands, backdrops and signage in Glengormley. Quick quotes, full setup & takedown.",
    h1: "Party Decorations in Glengormley",
    nearby: ["newtownabbey", "belfast", "jordanstown"],
    faqs: [
      { q: "Lead time?", a: "2–4 weeks recommended; we’ll try to help last-minute if we can." },
      { q: "Setup & takedown?", a: "Handled by our team." },
      { q: "Custom colours?", a: "Yes—share your palette or theme." },
      { q: "Minimum spend?", a: "Small installs available; ask for a quick quote." },
      { q: "Venue restrictions?", a: "We use venue-friendly, non-marking methods." }
    ],
    alt1: "Balloon garland framing a cake table at a Glengormley community hall; Party Crafters décor.",
    alt2: "Personalised welcome sign with balloon cluster in Glengormley; Party Crafters setup.",
  },
  {
    slug: "jordanstown",
    name: "Jordanstown",
    metaTitle: "Party Decorations Jordanstown | Balloons, Backdrops & Venue Décor",
    metaDescription:
      "Professional party décor in Jordanstown: garlands, personalised foil numbers, shimmer walls and welcome boards. Delivery, setup & takedown included.",
    h1: "Party Decorations in Jordanstown",
    nearby: ["newtownabbey", "belfast", "carrickfergus"],
    faqs: [
      { q: "What info do you need for a quote?", a: "Date, venue, theme/colours and any reference photos." },
      { q: "Do you install and remove?", a: "Yes—end-to-end service included." },
      { q: "Outdoor options?", a: "We’ll advise weather-suitable installs if needed." },
      { q: "Custom signage?", a: "Yes—personalised welcome boards available." },
      { q: "Payment?", a: "Deposit to book; balance before the event." }
    ],
    alt1: "Shimmer wall with balloon demi-arch inside a Jordanstown venue; Party Crafters.",
    alt2: "Compact personalised foil numbers with coordinated colours for a Jordanstown party; Party Crafters.",
  },
  {
    slug: "comber",
    name: "Comber",
    metaTitle: "Party Decorations Comber | Balloons, Backdrops & Venue Décor",
    metaDescription:
      "Balloon décor, shimmer walls and welcome boards in Comber. Quick quotes with delivery, setup & takedown included.",
    h1: "Party Decorations in Comber",
    nearby: ["newtownards", "bangor", "belfast"],
    faqs: [
      { q: "How early should I book?", a: "2–4 weeks recommended; earlier for peak dates." },
      { q: "What’s included?", a: "Professional delivery, setup and takedown." },
      { q: "Custom colours/themes?", a: "Yes—designed to suit your event." },
      { q: "Venue-friendly methods?", a: "Non-marking, approved fixings used." },
      { q: "Deposit?", a: "Small deposit secures your date." }
    ],
    alt1: "Balloon demi-arch with sequin panel for a Comber celebration; Party Crafters.",
    alt2: "Personalised welcome board with floral accents in Comber; Party Crafters setup.",
  },
  {
    slug: "dundonald",
    name: "Dundonald",
    metaTitle: "Party Decorations Dundonald | Balloons, Backdrops & Venue Décor",
    metaDescription:
      "Event décor in Dundonald: Surprise Room Décor, themed backdrops and welcome boards. Delivery, setup & takedown included.",
    h1: "Party Decorations in Dundonald",
    nearby: ["newtownards", "belfast", "holywood"],
    faqs: [
      { q: "Do you do small installs?", a: "Yes—personalised foil numbers and compact garlands available." },
      { q: "Setup & takedown?", a: "Handled by our team." },
      { q: "Theme matching?", a: "We’ll design around your brief or palette." },
      { q: "Travel fees?", a: "Local travel included; we’ll confirm on quote." },
      { q: "Outdoor use?", a: "We advise weather-appropriate options." }
    ],
    alt1: "Balloon garland and shimmer wall at a Dundonald function room; Party Crafters.",
    alt2: "Welcome board with mini balloon cluster for a Dundonald party; Party Crafters décor.",
  },
  {
    slug: "ballyclare",
    name: "Ballyclare",
    metaTitle: "Party Decorations Ballyclare | Balloons, Backdrops & Venue Décor",
    metaDescription:
      "Balloon garlands, personalised foil numbers, backdrops and signage in Ballyclare. Quick WhatsApp quotes. Full setup & takedown.",
    h1: "Party Decorations in Ballyclare",
    nearby: ["antrim", "newtownabbey", "belfast"],
    faqs: [
      { q: "Minimum spend?", a: "Small installs available; message us for options." },
      { q: "Included services?", a: "Delivery, setup and takedown." },
      { q: "Custom signage?", a: "Yes—personalised boards available." },
      { q: "Timing coordination?", a: "We liaise with your venue for access." },
      { q: "Deposit?", a: "A small deposit secures the date." }
    ],
    alt1: "personalised foil numbers with chrome detailing at a Ballyclare home; Party Crafters décor.",
    alt2: "Sequin backdrop and balloon demi-arch for a Ballyclare event; Party Crafters.",
  },
  {
    slug: "templepatrick",
    name: "Templepatrick",
    metaTitle: "Party Decorations Templepatrick | Balloons, Backdrops & Venue Décor",
    metaDescription:
      "Professional party décor in Templepatrick—balloon garlands, themed backdrops and welcome boards. Delivery, setup & takedown.",
    h1: "Party Decorations in Templepatrick",
    nearby: ["antrim", "belfast", "newtownabbey"],
    faqs: [
      { q: "How do I get a quote?", a: "WhatsApp us your date, venue and brief." },
      { q: "Do you install and remove?", a: "Yes—end-to-end service." },
      { q: "Colour matching?", a: "We match to your theme/brand." },
      { q: "Outdoor setups?", a: "We’ll advise what’s feasible." },
      { q: "Payment terms?", a: "Deposit to book; balance before event." }
    ],
    alt1: "Balloon demi-arch with shimmer wall at a Templepatrick venue; Party Crafters.",
    alt2: "Personalised welcome board with balloon cluster in Templepatrick; Party Crafters.",
  },
  {
    slug: "randalstown",
    name: "Randalstown",
    metaTitle: "Party Decorations Randalstown | Balloons, Backdrops & Venue Décor",
    metaDescription:
      "Balloon décor, backdrops and signage for Randalstown events. Quotes by WhatsApp. Setup & takedown included.",
    h1: "Party Decorations in Randalstown",
    nearby: ["antrim", "templepatrick", "belfast"],
    faqs: [
      { q: "Lead time?", a: "2–4 weeks recommended; ask for rush availability." },
      { q: "What’s included?", a: "Delivery, professional setup and takedown." },
      { q: "Custom options?", a: "Yes—personalised signs and colour palettes." },
      { q: "Venue rules?", a: "We use non-marking, venue-friendly methods." },
      { q: "Deposit?", a: "A small deposit secures your date." }
    ],
    alt1: "Balloon styling around a photo spot at a Randalstown event; Party Crafters.",
    alt2: "Welcome sign with balloon cluster for a Randalstown celebration; Party Crafters décor.",
  },
  {
    slug: "whitehead",
    name: "Whitehead",
    metaTitle: "Party Decorations Whitehead | Balloons, Backdrops & Venue Décor",
    metaDescription:
      "Decorate your Whitehead event with balloon garlands, personalised foil numbers, backdrops and welcome boards. Full setup & takedown.",
    h1: "Party Decorations in Whitehead",
    nearby: ["carrickfergus", "belfast", "greenisland"],
    faqs: [
      { q: "Do you handle logistics?", a: "Yes—delivery, setup and takedown are included." },
      { q: "Coastal installs?", a: "We plan weather-friendly options if outdoors." },
      { q: "Personalisation?", a: "Yes—custom signage and palettes." },
      { q: "Evening takedown?", a: "Usually next-day; same-night can be arranged." },
      { q: "Travel fees?", a: "Local travel typically included; we’ll confirm on quote." }
    ],
    alt1: "Balloon garland with shimmer backdrop at a Whitehead venue; Party Crafters.",
    alt2: "Welcome board and coordinated balloon display styled for a Whitehead celebration; Party Crafters.",
  },
  {
    slug: "greenisland",
    name: "Greenisland",
    metaTitle: "Party Decorations Greenisland | Balloons, Backdrops & Venue Décor",
    metaDescription:
      "Greenisland party décor: stylish balloon garlands, themed backdrops and personalised welcome boards. Setup & takedown included.",
    h1: "Party Decorations in Greenisland",
    nearby: ["newtownabbey", "carrickfergus", "belfast"],
    faqs: [
      { q: "How do I book?", a: "Send us your date, venue and theme on WhatsApp." },
      { q: "Is setup included?", a: "Yes—our team handles setup and takedown." },
      { q: "Custom colours/themes?", a: "Absolutely—share your palette or ideas." },
      { q: "Small installs?", a: "Yes—personalised foil numbers and compact garlands available." },
      { q: "Venue-friendly methods?", a: "Non-marking fixings used where required." }
    ],
    alt1: "Balloon demi-arch and sequin panel styled at a Greenisland event; Party Crafters.",
    alt2: "Personalised welcome board with balloon cluster in Greenisland; Party Crafters décor.",
  },

  /* ---------- Aliases (redirect + excluded from sitemap) ---------- */

  {
    slug: "belfast-city",
    name: "Belfast City",
    canonicalTo: "belfast",
    active: false,
    noindex: true,
  },
  {
    slug: "newtown-abbey",
    name: "Newtown Abbey",
    canonicalTo: "newtownabbey",
    active: false,
    noindex: true,
  },
  {
    slug: "bangor-ni",
    name: "Bangor NI",
    canonicalTo: "bangor",
    active: false,
    noindex: true,
  },
  {
    slug: "newtown-ards",
    name: "Newtown Ards",
    canonicalTo: "newtownards",
    active: false,
    noindex: true,
  },
];

export const listedTowns = towns.filter(
  (t) => !t.canonicalTo || t.canonicalTo === t.slug
);
